module.exports = __webpack_public_path__ + "img/logo2.af254168.png";